/**
 * 참고(API) : https://github.kakaocorp.com/kakaopage/api/blob/ed7f030bf20be917cf5b81130ffc7e5beaf3f2bb/common/src/main/java/com/kakaopage/common/model/enums/ReadAccessType.java#L6
 */
export enum ReadAccessTypeVo {
  /**
   * 구매하지 않음
   */
  NotPurchased = 'RAT1',
  /**
   * 읽을수 있음
   */
  CanRead = 'RAT2',
  /**
   * 대여했으나 만료됨
   */
  Expired = 'RAT3',
  /**
   * 열람가능한 연재상품
   */
  CanReadSerialize = 'RAT4',
  /**
   * 웹에서 열람 불가능한 상품
   */
  UnreadableWeb = 'RAT5',
  /**
   * 웹에서 연령제한으로 열람 불가
   */
  UnreadableWebAgeLimit = 'RAT6',
}
